import React, {Component} from 'react'
import {connect} from 'react-redux'
import {actions as cartActions} from '../../../redux/modules/Cart'
import {bindActionCreators} from "redux";
import PaymentPage from "./PaymentPage";
import SostaOnlineApiService from '../../../services/SostaOnlineApiService'
import PaymentResult from "./PaymentResult";
import queryString from 'query-string'
import Loading from "../../../components/LoadingComponent";

const MOCK_TRANSACTION_OK = {"TransactionType":"DECRYPT", "TransactionResult":"OK","ShopTransactionID":"SOSTA_COMUNE_DI_PERO-48","BankTransactionID":"25","AuthorizationCode":"137519","Currency":"242","Amount":"0.10","Country":"ITALIA","CustomInfo":null,"Buyer":{"BuyerName":null,"BuyerEmail":null},"TDLevel":null,"ErrorCode":"0","ErrorDescription":"Transazione correttamente effettuata","AlertCode":null,"AlertDescription":null,"VbVRisp":null,"VbVBuyer":null,"VbVFlag":null,"TransactionKey":null,"AVSResultCode":null,"AVSResultDescription":null,"RiskResponseCode":null,"RiskResponseDescription":null}
const MOCK_TRANSACTION_KO = {TransactionResult: 'KO', ErrorCode: 'B2S', ErrorDescription: 'Errore di comunicazione con il gateway', Amount: 0};

const mapStateToProps = (state) => {
    return {
        cart: state.cart
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        cartActions: bindActionCreators(cartActions, dispatch)
    };
};

class PaymentResultContainer extends Component {

    constructor(props) {
        super(props);

        this.state = {
            paymentResult: null,
            loading: false,
            error: null
        };
    }

    componentWillMount() {
        this.setState({loading: true});
        const parsed = queryString.parse(this.props.location.search);
        SostaOnlineApiService.decryptOperationResult(parsed.a, parsed.b).then(data => {
            console.log("risultato pagamento", data);
            this.setState({paymentResult: data.data, loading: false});
            this.props.cartActions.clearAll()
        }).catch(err => {
            this.setState({paymentResult: {
                TransactionResult: 'KO',
                ErrorCode: 'B2S',
                ErrorDescription: 'Errore di comunicazione con il gateway',
                Amount: 0
            }, loading: false})
        });
    }


    render() {
        if(this.state.loading) {
            return(<Loading/>)
        }

        //return (<PaymentResult result={MOCK_TRANSACTION_OK} error={this.state.error} />);
        return (<PaymentResult result={this.state.paymentResult} error={this.state.error} />);
    }
}

PaymentResultContainer.propTypes = {
};

export default connect(mapStateToProps, mapDispatchToProps)(PaymentResultContainer);




// WEBPACK FOOTER //
// ./src/containers/UserArea/Checkout/PaymentResultContainer.js